import { Link } from 'react-router-dom';

const content = {
  paragraphs: [
    "Modern Nomad Living is built by passionate researchers and enthusiasts who believe that home is more than four walls and a mortgage. We're not professional nomads with book deals — we're curious people who spend countless hours researching, interviewing, and learning from those who've chosen alternative paths.",
    "Every article on this site comes from genuine interest and careful research. We share the practical details others often skip: the real costs, the unexpected challenges, the legal gray areas, and the honest rewards. No sugarcoating, no selling a dream. Just useful information for those considering a different way of living."
  ],
  closingText: "Whether you're planning your first weekend camping trip or dreaming of sailing around the world, we're here to help you take that first step.",
  exploreLinks: [
    { text: 'Van Life Guide', url: '/article/van-life-basics-complete-guide' },
    { text: 'Camping Basics', url: '/article/camping-basics-complete-guide' }
  ]
};

export const AboutSection = () => {
  return (
    <section className="relative py-16 md:py-24">
      {/* Decorative top line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />

      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-primary text-center mb-10">
          Who We Are
        </h2>
        <div className="space-y-6 text-lg text-foreground/85 leading-relaxed">
          {content.paragraphs.map((paragraph, index) => (
            <p 
              key={index}
              className="animate-fade-in font-light"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {paragraph}
            </p>
          ))}
          
          <p className="animate-fade-in text-primary font-medium" style={{ animationDelay: '300ms' }}>
            {content.closingText}
          </p>
          
          <div className="pt-4 animate-fade-in" style={{ animationDelay: '450ms' }}>
            <p className="text-muted-foreground mb-3 text-sm">Start exploring:</p>
            <div className="flex flex-wrap gap-4">
              {content.exploreLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.url}
                  className="inline-flex items-center border border-accent/40 text-accent hover:border-accent hover:bg-accent/5 px-4 py-2 text-[10px] tracking-luxury uppercase font-normal transition-all duration-500"
                >
                  {link.text}
                </Link>
              ))}
            </div>
          </div>
        </div>
        
        <div className="text-center mt-8">
          <Link 
            to="/about"
            className="inline-flex items-center text-accent/80 hover:text-accent text-[10px] tracking-luxury uppercase font-normal transition-colors duration-500"
          >
            Learn more about us
            <span className="ml-2 transform group-hover:translate-x-1 transition-transform duration-500">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
};
